import { useEffect, useState } from 'react';

/**
 * True once the picture should be in its own colour.
 *
 * The banner loads black and white and turns colour where the reader can see
 * it happen, rather than the change being tied to the scroll position — the
 * banner is the first thing on the page now, so there is no travel to hang it
 * on.
 *
 * False on the server and for the first moment on the client, so the browser
 * has a grey value to transition away from — setting the end state in the same
 * paint gives no transition at all.
 */
export const useColourOnArrival = (enabled: boolean): boolean => {
    const [arrived, setArrived] = useState(false);

    useEffect(() => {
        if (!enabled) {
            setArrived(true);
            return;
        }

        // A timer rather than `requestAnimationFrame`: a tab that is not
        // painting never runs a frame callback, and the picture would stay
        // grey for as long as it was in the background.
        const timer = setTimeout(() => setArrived(true), 60);
        return () => clearTimeout(timer);
    }, [enabled]);

    return arrived;
};
